export default "__VITE_ASSET___tQ7Kt8j__"